<form [formGroup]="formGroup" class="grid grid-cols-1 gap-2 my-2">
    <div class="my-2">
        <div class="grid grid-cols-4 gap-2">
            <div class="col-span-4" *ngIf="valveType == 'cValve' || valveType == 'ssValve'">
                <mat-label>{{ valveType == 'cValve' ? 'Additional Gate Valve Testing Remarks' : 'Additional Remarks'}}
                </mat-label>
                <mat-form-field class="custom-mat-form-field w-full">
                    <input matInput class="input" formControlName="gateValveTesting" />
                </mat-form-field>
            </div>

            <div class="col-span-1">
                <mat-label>Valve Tested</mat-label>
                <mat-form-field class="mat-disabled custom-mat-form-field w-full">
                    <mat-select matNativeControl formControlName="valvedTest">
                        <mat-option value="Yes">Yes</mat-option>
                        <mat-option value="UTT">UTT</mat-option>
                        <mat-option value="NA">NA</mat-option>
                    </mat-select>

                    <!-- <input
                        matInput
                        class="input"
                        formControlName="valvedTest"
                        [matAutocomplete]="valveTested"
                    />
                    <mat-autocomplete
                        autoActiveFirstOption
                        #valveTested="matAutocomplete"
                    >
                        <mat-option value="Yes">Yes</mat-option>
                        <mat-option value="UTT">UTT</mat-option>
                        <mat-option value="NA">NA</mat-option>
                    </mat-autocomplete> -->
                </mat-form-field>
            </div>
            <div class="col-span-3">
                <mat-label>Remarks <span class="text-sm text-gray-700">(if UTT/NA)</span></mat-label>
                <mat-form-field class="custom-mat-form-field w-full">
                    <input matInput class="input" formControlName="remarks" />
                </mat-form-field>
            </div>
        </div>
    </div>
</form>
<hr />

<form [formGroup]="formGroup" class="valve-form w-full grid grid-cols-3 gap-2">
    <div class="my-2">
        <mat-label>Size</mat-label>
        <mat-form-field class="custom-mat-form-field w-full">
            <input matInput class="input" formControlName="sizeIn" />
            <span matTextSuffix>inch</span>
        </mat-form-field>
    </div>
    <div class="my-2">
        <mat-label>Equipment Brand / OEM</mat-label>
        <mat-form-field class="custom-mat-form-field w-full">
            <input matInput class="input" formControlName="equipmentBrand" />
        </mat-form-field>
    </div>
    <div class="my-2">
        <mat-label>Rating</mat-label>
        <mat-form-field class="custom-mat-form-field w-full">
            <input matInput class="input" formControlName="ratingPsi" />
            <span matTextSuffix>psi</span>
        </mat-form-field>
    </div>
    <!-- <div class="my-2">
        <mat-label>OEM</mat-label>
        <mat-form-field class="custom-mat-form-field w-full">
            <input matInput class="input" formControlName="oem" />
        </mat-form-field>
    </div> -->
</form>

<form [formGroup]="formGroup" class="valve-form w-full grid grid-rows-2 grid-flow-col gap-2 my-2">
    <div class="my-2">
        <mat-label>Actuator Model</mat-label>
        <mat-form-field class="custom-mat-form-field w-full">
            <input matInput class="input" formControlName="actuatorModel" />
        </mat-form-field>
    </div>
    <!-- <div class="my-2">
        <mat-label>Opening <span class="text-sm text-gray-700">(as per specification)</span></mat-label>
        <div class="grid grid-cols-2 gap-2">
            <mat-form-field class="custom-mat-form-field w-full">
                <input matInput class="input" formControlName="openingSec" />
                <span matTextSuffix>sec</span>
            </mat-form-field>
            <mat-form-field class="custom-mat-form-field w-full">
                <input matInput class="input" formControlName="openingCm" />
                <span matTextSuffix>cm</span>
            </mat-form-field>
        </div>
    </div> -->
    <div class="my-2">
        <mat-label>Opening</mat-label>
        <div class="grid grid-cols-2 gap-2">
            <mat-form-field class="custom-mat-form-field w-full">
                <input matInput class="input" formControlName="openingCdftSec" />
                <span matTextSuffix>sec</span>
            </mat-form-field>
            <mat-form-field class="custom-mat-form-field w-full">
                <input matInput class="input" type="number" formControlName="openingCdftCm" />
                <span matTextSuffix>cm</span>
            </mat-form-field>
        </div>
    </div>
    <div class="my-2">
        <mat-label>Actuator Type</mat-label>
        <mat-form-field class="custom-mat-form-field w-full">
            <input matInput class="input" formControlName="actuatorType" />
        </mat-form-field>
    </div>
    <!-- <div class="my-2">
        <mat-label>Closing <span class="text-sm text-gray-700">(as per specification)</span></mat-label>
        <div class="grid grid-cols-2 gap-2">
            <mat-form-field class="custom-mat-form-field w-full">
                <input matInput class="input" formControlName="closingSec" />
                <span matTextSuffix>sec</span>
            </mat-form-field>
            <mat-form-field class="custom-mat-form-field w-full">
                <input matInput class="input" formControlName="closingCm" />
                <span matTextSuffix>cm</span>
            </mat-form-field>
        </div>
    </div> -->
    <div class="my-2">
        <mat-label>Closing </mat-label>
        <div class="grid grid-cols-2 gap-2">
            <mat-form-field class="custom-mat-form-field w-full">
                <input matInput class="input" formControlName="closingCdftSec" />
                <span matTextSuffix>sec</span>
            </mat-form-field>
            <mat-form-field class="custom-mat-form-field w-full">
                <input matInput class="input" type="number" formControlName="closingCdftCm" />
                <span matTextSuffix>cm</span>
            </mat-form-field>
        </div>
    </div>

</form>

<!-- <div *ngIf="input"> -->
<!-- <form [formGroup]="formGroup" class="valve-form w-full grid grid-cols-2 gap-2 my-2" *ngIf="valveType != 'ssValve'">
    <div class="my-2">
        <mat-label>Fully Open <span class="text-sm text-gray-700">(as per specification)</span></mat-label>
        <mat-form-field class="custom-mat-form-field w-full">
            <input matInput class="input" formControlName="fullyOpen" />
            <span matTextSuffix>turns</span>
        </mat-form-field>
    </div>
    <div class="my-2">
        <mat-label>Fully Close <span class="text-sm text-gray-700">(as per specification)</span></mat-label>
        <mat-form-field class="custom-mat-form-field w-full">
            <input matInput class="input" formControlName="fullyClose" />
            <span matTextSuffix>turns</span>
        </mat-form-field>
    </div>
</form> -->

<form [formGroup]="formGroup" class="valve-form w-full grid grid-cols-2 gap-2 my-2" *ngIf="valveType != 'ssValve'">
    <div class="my-2">
        <mat-label>Fully Open </mat-label>
        <mat-form-field class="custom-mat-form-field w-full">
            <input matInput class="input" type="number" formControlName="fullyOpenCdft" />
            <span matTextSuffix>turns</span>
        </mat-form-field>
    </div>
    <div class="my-2">
        <mat-label>Fully Close </mat-label>
        <mat-form-field class="custom-mat-form-field w-full">
            <input matInput class="input" type="number" formControlName="fullyCloseCdft" />
            <span matTextSuffix>turns</span>
        </mat-form-field>
    </div>
</form>

<form [formGroup]="formGroup" class="valve-form w-full grid grid-cols-2 gap-2 my-2">
    <div class="my-2 col-span-2">
        <mat-label>Jammed</mat-label>
        <div class="grid grid-cols-2">
            <mat-radio-group class="grid grid-cols-1 sm:grid-cols-2 items-center radio-en"
                formControlName="jammedPosition">
                <mat-radio-button class="col-span-1" [value]="'open'">
                    Open
                </mat-radio-button>
                <mat-radio-button class="col-span-1" [value]="'close'">
                    Close
                </mat-radio-button>
            </mat-radio-group>
            <mat-form-field class="custom-mat-form-field w-full">
                <input matInput class="input" formControlName="jammed" />
                <span matTextSuffix>turns</span>
            </mat-form-field>
        </div>
    </div>
</form>

<form [formGroup]="formGroup" class="valve-form w-full grid grid-cols-2 gap-2 my-2">
    <div class="my-2 col-span-1">
        <mat-label>Hydraulic Return</mat-label>
        <mat-form-field class="custom-mat-form-field w-full">
            <input matInput class="input" formControlName="hydraulicReturn" />
            <span matTextSuffix>ml</span>
        </mat-form-field>
    </div>
</form>

<!-- </div> -->

<hr />

<form [formGroup]="formGroup" class="valve-form w-full grid grid-cols-3 gap-2 my-2">
    <div class="col-span-3 grid grid-cols-1 gap-2 my-2">
        <div class="my-2">
            <div class="grid grid-cols-4 gap-2">
                <mat-form-field class="custom-mat-form-field w-full col-span-2">
                    <mat-label>Finding</mat-label>
                    <mat-select matNativeControl formControlName="finding">
                        <mat-option value="ALL GOOD">ALL GOOD</mat-option>
                        <mat-option value="LEAK">LEAK</mat-option>
                        <mat-option value="CORRODED">CORRODED</mat-option>
                        <mat-option value="OTHERS">OTHERS</mat-option>
                    </mat-select>

                    <!-- <input matInput class="input" formControlName="finding" [matAutocomplete]="finding" readonly
                    (click)="findingInput.openPanel()" #findingInput="matAutocompleteTrigger" />
                <mat-autocomplete autoActiveFirstOption #finding="matAutocomplete">
                    <mat-option value="ALL GOOD">ALL GOOD</mat-option>
                    <mat-option value="LEAK">LEAK</mat-option>
                    <mat-option value="CORRODED">CORRODED</mat-option>
                </mat-autocomplete> -->
                </mat-form-field>

                <mat-form-field class="custom-mat-form-field w-full col-span-2">
                    <mat-label>Others</mat-label>
                    <input matInput class="input" formControlName="othersFinding" />
                </mat-form-field>
            </div>
        </div>
        <div class="my-2">
            <div class="grid grid-cols-3 gap-2">
                <div class="col-span-2">
                    <mat-label>Greasing</mat-label>
                    <mat-form-field class="custom-mat-form-field w-full">
                        <input matInput class="input" formControlName="greasing" type="number" />
                        <span matTextSuffix>Lbs</span>
                    </mat-form-field>
                </div>
                <div class="col-span-1">
                    <mat-label>Type</mat-label>
                    <mat-form-field class="custom-mat-form-field w-full">
                        <input matInput class="input" formControlName="greasingType" />
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="my-2">
            <div class="grid grid-cols-3 gap-2">
                <div class="col-span-2">
                    <mat-label>Flushing</mat-label>
                    <mat-form-field class="custom-mat-form-field w-full">
                        <input matInput class="input" formControlName="flushing" type="number" />
                        <span matTextSuffix>Litre</span>
                    </mat-form-field>
                </div>
                <div class="col-span-1">
                    <mat-label>Type</mat-label>
                    <mat-form-field class="custom-mat-form-field w-full">
                        <input matInput class="input" formControlName="flushingType" />
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="my-2">
            <div class="grid grid-cols-3 gap-2">
                <div class="col-span-2">
                    <mat-label>Sealing</mat-label>
                    <mat-form-field class="custom-mat-form-field w-full">
                        <input matInput class="input" formControlName="sealing" type="number" />
                        <span matTextSuffix>Lbs</span>
                    </mat-form-field>
                </div>
                <div class="col-span-1">
                    <mat-label>Type</mat-label>
                    <mat-form-field class="custom-mat-form-field w-full">
                        <input matInput class="input" formControlName="sealingType" />
                    </mat-form-field>
                </div>
            </div>
        </div>
    </div>
</form>
<hr />

<form [formGroup]="formGroup.controls.cdftXmtWhvGreasing.controls.before">
    <div class="grid grid-cols-12 text-center">
        <div class="col-span-12 border-table bg-Grey py-2 font-bold">
            BEFORE GREASING
        </div>
        <div class="col-span-1 border-table">Time (min)</div>
        <div *ngFor="let minute of minutes; let i = index" class="col-span-1 border-table">
            <div class="text-center h-full w-full">{{ minute }}</div>
        </div>
        <div class="col-span-1 border-table">Pressure (psi)</div>
        <div *ngFor="let minute of minutes; let i = index" class="col-span-1 border-table">
            <input class="text-center h-full w-full" [formControlName]="'time' + minute" type="number" />
        </div>
    </div>
</form>

<form [formGroup]="formGroup.controls.cdftXmtWhvGreasing.controls.after" class="mt-2">
    <div class="grid grid-cols-12 text-center">
        <div class="col-span-12 border-table bg-Grey py-2 font-bold">
            AFTER GREASING
        </div>
        <div class="col-span-1 border-table">Time (min)</div>
        <div *ngFor="let minute of minutes; let i = index" class="col-span-1 border-table">
            {{ minute }}
        </div>
        <div class="col-span-1 border-table">Pressure (psi)</div>
        <div *ngFor="let minute of minutes; let i = index" class="col-span-1 border-table">
            <input class="text-center h-full w-full" [formControlName]="'time' + minute" type="number" />
        </div>
    </div>
</form>

<div class="grid grid-cols-1 sm:grid-cols-4 gap-6 w-full min-w-0">
    <div class="sm:col-span-2 flex flex-col flex-auto">
        <table class="valveResult">
            <tr>
                <td colspan="2" class="text-left" style="border: none">
                    For UTT, leave the pressure value empty
                </td>
            </tr>
            <tr>
                <th rowspan="2" class="bg-Grey w-1/4">RESULT</th>
                <td>BEFORE</td>
                <!-- bg-good -->
                <td [ngClass]="{
                        'bg-good': beforeResult === 'good',
                        'bg-warning': beforeResult === 'degraded',
                        'bg-error text-white': beforeResult === 'fail',
                    }">
                    {{
                    formGroup.controls.cdftXmtWhvGreasing.controls.before
                    .value.result | uppercase
                    }}
                </td>
            </tr>
            <tr>
                <td>AFTER</td>
                <td [ngClass]="{
                        'bg-good': afterResult === 'good',
                        'bg-warning': afterResult === 'degraded',
                        'bg-error text-white': afterResult === 'fail',
                    }">
                    {{
                    formGroup.controls.cdftXmtWhvGreasing.controls.after
                    .value.result | uppercase
                    }}
                </td>
            </tr>
        </table>
    </div>

    <div class="sm:col-span-2 flex flex-col flex-auto">
        <table class="valveResult">
            <tr>
                <td style="border: none"><br /></td>
            </tr>
            <tr>
                <td class="w-1/4">Actual Leak Rate</td>
                <td class="w-1/4">
                    {{ safeNumber(formGroup.getRawValue().actualLeakRate) }}
                </td>
            </tr>
        </table>
    </div>
</div>